module.exports = __webpack_public_path__ + "img/chevron-right.bb4acdd5.svg";